import React, { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate } from "react-router";
import * as adminApi from "../../../../service/adminApi";
// import TextEditer from "../material/textEditor/TextEditor";
import TinyMCE from "../../../material/tinymce/TinyMCE";
// import Draft from "../material/texteditorDraft/Draft";
import Datepicker from "../../../material/datepicker/Datepicker";
import ToggleCheckbox from "../../../material/toggleCheckbox/ToggleCheckbox";
import { RedirectCode400 } from "../../../RedirectCode400";
import { CurrentUserContext } from "../../../../App";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";

function AddLaboratory() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [titlepage, setTitlePage] = useState("");
  const [titleValue, setTitleValue] = useState("");
  const [detailValue, setDetailValue] = useState(location.state?.detail ?? "");
  const [publishStartDate, setPublishStartDate] = useState(
    location.state?.publishStartDate?.date || "",
  );
  const [publishEndDate, setPublishEndDate] = useState(
    location.state?.publishEndDate?.date || "",
  );

  const [active, setActive] = useState(location.state?.active ?? true);
  const [pined, setPined] = useState(location.state?.pined ?? false);
  const [title, setTitle] = useState(location.state?.title ?? "");

  const [defaultOption, setDefaultOption] = useState("");

  useEffect(() => {
    if (location.state?.type === "guideline") {
      setTitlePage("เพิ่มแนวทางการตรวจ");
      setTitleValue(location.state?.type);
      setDefaultOption("1");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      navigate("/");
    }
  }, []);

  const addGuideline = async () => {
    setLoading(true);
    let res = await adminApi.addGuideline(
      titleValue,
      title,
      detailValue,
      pined,
      active,
      publishStartDate,
      publishEndDate,
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/laboratory-inspection-guideline");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateGuideline = async () => {
    setLoading(true);
    let res = await adminApi.updateGuideline(
      location.state?.id,
      titleValue,
      title,
      detailValue,
      pined,
      active,
      publishStartDate,
      publishEndDate,
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/laboratory-inspection-guideline");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onClickAddSubmit = (type) => {
    if (!titleValue) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหัวข้อ" });
    } else if (!detailValue) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรายละเอียด" });
    } else if (!publishStartDate) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันที่เผยแพร่" });
    } else {
      if (type === "guideline") {
        location.state?.detail ? updateGuideline() : addGuideline();
      }
    }
  };

  return (
    <div className="min-w-[708px] md:min-w-[376px] overflow-x-auto">
      <PageHeaderV2 titlename={titlepage ?? ""} />
      <div className="flex flex-row justify-center items-start md:flex-col w-full gap-[20px]">
        <div className="rounded-[6px] border-[#E2E2E4] border w-[70%] md:w-[100%] p-[9px_16px]">
          <div className="flex flex-col text-[16px] font-['Prompt']">
            หัวข้อ
            <input
              type="text"
              className="border border-solid border-[#E0DFE2] rounded-[5px] md:text-[14px] text-[#000000] p-2 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full h-[38px]"
              placeholder=""
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div>
            <div className="md:text-[14px] text-[16px] text-[#000000] md:my-1 my-3 font-['Prompt']">
              รายละเอียด
            </div>

            <TinyMCE
              readOnly={false}
              value={detailValue}
              setValue={setDetailValue}
            />
          </div>
        </div>
        <div className="md:w-full">
          <div className="rounded-[6px] border-[#E2E2E4] border w-[100%] md:w-[100%] p-[9px_16px]">
            {/* enable check edit  */}
            {/* <div className="flex flex-col gap-[8px] font-['Prompt'] text-[16px] mb-[10px]">
              ปักหมุด
              <ToggleCheckbox label="" value={pined} setValue={setPined} />
            </div> */}
            <div className="flex flex-col mt-4 font-['Prompt'] text-[16px] mb-[10px]">
              วันที่เเสดง
              <Datepicker
                label=""
                value={publishStartDate}
                setValue={setPublishStartDate}
                className="md:text-[14px] text-xl text-[#000000] font-['Prompt'] text-[16px]"
                title="publicity"
              ></Datepicker>
            </div>
            <div className="flex flex-col mt-4 font-['Prompt'] text-[16px] mb-[10px]">
              วันที่หมดอายุ
              <Datepicker
                label=""
                value={publishEndDate}
                setValue={setPublishEndDate}
                className="md:text-[14px] text-xl text-[#000000] font-['Prompt'] text-[16px]"
                title="publicity"
              ></Datepicker>
            </div>
            <div className="flex flex-col gap-[8px] mt-4 font-['Prompt'] text-[16px] mb-[10px]">
              สถานะที่เผยเเพร่
              <ToggleCheckbox label="" value={active} setValue={setActive} />
            </div>
          </div>
          <div className="flex flex-row gap-3 justify-end items-center mt-[10px] md:justify-center">
            <button
              onClick={() => {
                navigate("/admin/management/laboratory-inspection-guideline");
              }}
              className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#C0C0C0] rounded-[5px] gap-1 text-[#FFFFFF] "
            >
              ยกเลิก
            </button>
            <button
              onClick={() => {
                onClickAddSubmit(location.state?.type);
              }}
              className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#2EA669] rounded-[5px] gap-1 text-[#FFFFFF] "
            >
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddLaboratory;
